<mat-form-field
    appearance="outline"
    [floatLabel]="floatLabel"
    [ngClass]="{ simpleInput: simpleInput, 'full-width': fullWidth}"
>
    <mat-label *ngIf="!simpleInput">
        ATTENTION: Don't use AUM-Form-field directly. use an alteantive like Aum-Input
        <ng-content select="aum-form-field-label"></ng-content>
    </mat-label>

    <input #input matInput [placeholder]="placeholder" autocomplete="nothing" [formControl]="aumFormControl" />
    <mat-error *ngIf="!simpleInput && aumFormControl && aumFormControl.invalid">
        <span class="aumico-pattern-icon-alert-triangle"><i></i></span>
        <ng-content select="aum-form-error"></ng-content>
    </mat-error>
</mat-form-field>
